// Sticky element on Home Page
// stickybits('.feat-quote', {useStickyClasses: true, scrollEl: '#MainContent'});

// Best Products Slider on Home Page
$(document).ready(function(){
  $('.best-prod').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 4,
    responsive: [
  {
    breakpoint: 1200,
    settings: {
      slidesToShow: 5,
      slidesToScroll: 4,
      infinite: true,
    }
  },
  {
    breakpoint: 900,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2,
    }
  },
  {
    breakpoint: 600,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
    }
  }
]
  });

$('.hero-slide').slick({
  dots: false,
  infinite: true,
  speed: 300,
  autoplay: true,
  autoplaySpeed: 3500,
  slidesToShow: 1
})


});
